<template>
  <AppDrawer v-model="showModal" :dialog-titel="title">
    <template #header>
      <div>
        <h5 class="heading-xs">{{ title }}</h5>
        <p>{{ description }}</p>
      </div>
    </template>

    <div
      v-for="(filterGroup, groupIndex) in filterStore.filters"
      :key="groupIndex"
      class="flex flex-col pb-32"
    >
      <p class="text-20">{{ filterGroup.title }}</p>
      <p class="text-20 leading-24">
        {{ filterGroup.description }}
      </p>
      <div class="pt-8 flex gap-8 flex-wrap">
        <FilterInputButton
          v-if="filterGroup.type !== 'radio'"
          :disabled="
            !Object.keys(filterStore.activeFilters[filterGroup.title] ?? {})
              .length
          "
          :checked="
            !Object.keys(filterStore.activeFilters[filterGroup.title] ?? {})
              .length
          "
          @on-clicked="() => filterStore.clearGroup(filterGroup.title)"
        >
          <template #label>
            <div class="align-bottom">Alla</div>
          </template>
        </FilterInputButton>
        <template v-for="filter in filterGroup.filters" :key="filter.filterId">
          <FilterLinkButton
            v-if="filter.linkUrl"
            :url="filter.linkUrl"
            :title="filter.name"
          />
          <FilterInputButton
            v-else-if="
              filter.isAlternative ===
              filterStore.groupsWithAlternativesChecked[filterGroup.title]
            "
            :filter-id="filter.filterId"
            :type="filterGroup.type || 'checkbox'"
            :radio-group-name="
              filterGroup.type === 'radio' ? filterGroup.title : undefined
            "
            :checked="filterStore.isFilterActiveById[filter.filterId ?? '']"
            @on-clicked="onFilterToggleClicked(filter.filterId)"
          >
            <template #label>
              {{ filter.name }}
            </template>
          </FilterInputButton>
        </template>
        <FilterCheckBox
          v-if="filterGroup.alternateTitle"
          class="mt-4 w-full"
          :label="filterGroup.alternateTitle"
          :title="filterGroup.title"
          :checked="filterStore.isAlternativesChecked(filterGroup.title)"
        />
      </div>
    </div>

    <template #footer>
      <div
        class="flex flex-row items-center gap-16 flex-wrap py-24 w-full lg:w-fit mx-24"
      >
        <AppButton
          class="w-full lg:w-fit"
          color="primary"
          :full-width="true"
          @on-click="showModal = false"
        >
          Visa {{ numberOfResults }} resultat
        </AppButton>
        <AppButton
          color="secondary"
          class="w-full lg:w-fit"
          :full-width="true"
          @on-click="filterStore.clearFilters"
          >rensa</AppButton
        >
      </div>
    </template>
  </AppDrawer>
</template>

<script setup lang="ts">
const filterStore = useFilterStore();
const showModal = defineModel<boolean>();

withDefaults(
  defineProps<{
    title: string;
    description: string;
    numberOfResults: number;
  }>(),
  {},
);

const onFilterToggleClicked = (filterId: string) => {
  filterStore.toggle(filterId);
};
</script>
